import { usePageTracking } from '@/hooks/usePageTracking';

/**
 * Component that tracks page views on route changes
 * Must be placed inside BrowserRouter
 */
const RouteTracker = () => {
  usePageTracking();
  return null;
};

export default RouteTracker;
